var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg6(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13 2.16663L4.10583 5.87163V11.9708C4.10583 17.4525 7.8975 22.5875 13 23.8875C18.1025 22.6416 21.8942 17.5066 21.8942 12.025V5.87163L13 2.16663ZM13 6.27246C13.6592 6.27261 14.2979 6.50132 14.8073 6.9196C15.3168 7.33788 15.6654 7.91987 15.7939 8.56639C15.9223 9.21291 15.8226 9.88398 15.5118 10.4652C15.2009 11.0465 14.6982 11.502 14.0891 11.7541C13.4801 12.0063 12.8025 12.0394 12.1717 11.8479C11.541 11.6565 10.9962 11.2522 10.63 10.7041C10.2639 10.156 10.0992 9.49784 10.1639 8.84186C10.2287 8.18589 10.5188 7.57265 10.985 7.10663C11.2496 6.84208 11.5638 6.63225 11.9095 6.48912C12.2553 6.34599 12.6258 6.27237 13 6.27246ZM17.4525 18.3516C16.3174 19.8293 14.767 20.9345 13 21.5258C11.233 20.9345 9.68263 19.8293 8.5475 18.3516V15.9141C8.5475 14.105 11.5158 13.1841 13 13.1841C14.4842 13.1841 17.4525 14.105 17.4525 15.9141V18.3516Z",
    fill: "#B7E4EA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13 2.16663V6.27246C13.7556 6.27246 14.4803 6.57264 15.0147 7.10696C15.549 7.64128 15.8492 8.36598 15.8492 9.12163C15.8492 9.87727 15.549 10.602 15.0147 11.1363C14.4803 11.6706 13.7556 11.9708 13 11.9708V13.1841C14.4842 13.1841 17.4525 14.105 17.4525 15.9141V18.3516C16.3174 19.8293 14.767 20.9345 13 21.5258V23.8333C18.1025 22.5875 21.8942 17.4525 21.8942 11.9708V5.87163L13 2.16663Z",
    fill: "#B7E4EA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg6);
export default __webpack_public_path__ + "static/media/6.db007660b2dc32b32cab9c9d7afdec1b.svg";
export { ForwardRef as ReactComponent };